import { getArticleContent,getFocusUserInfo } from '@/js/request/commentRequest'
import { getUserInfo } from '@/js/request/uisRequest.js';
import Utils from "@/utils/util"

// 默认8分回调函数
const getArticleContentFn = async ()=>{
    const res = await getArticleContent()
    if(res?.data?.fulltext?.content) {
        renderContent('#articleContent .display-content',res?.data?.fulltext?.content) // 渲染全文
        renderTitle(res?.data?.fulltext?.title) // 渲染标题
        emitRunClientJs()
    }else {
        jumpHome()
    }
}

// 8分文章页：只有作者可见
export const authorAccessArticle = async (fb) => {
    try {
        console.log('8分作者可见....')
        let callBack = fb || getArticleContentFn
        const res = isFocusArticle() ? await getFocusUserInfo() : await getUserInfo()
        if (res?.data && (res?.data?.userId || res?.data?.uid)) { // 登录用户
            callBack()
            setTimeout(()=>{removeSkeleton()},1000)
            renderHideDom()
        }else {
            jumpHome()
        }
    } catch (error) {
        jumpHome()
    }
}

// 登陆限制
export const loginAccessArticle = async () => {
    // 命中权益的文章
    window?.sohuSpm?.sendAction({ 
        acode: 11064,
        clkParam: `displayMode:${cfgs?.displayMode};articleId:${cfgs?.newsId};`
    })
    try {
        console.log('登陆限制....')
        // 已登录
        const userInfo = isFocusArticle() ? await getFocusUserInfo() : await getUserInfo()
        if (userInfo?.data && (userInfo?.data?.userId || userInfo?.data?.uid)) {
            renderHeadVideoDom()
            const isFromLogin = document.referrer.includes('m.sohu.com/login/') || document.referrer.includes('login.focus.cn/') || false  // 来自登录页
            const isUnfoldContent = localStorage.getItem('clickUnfoldContent') || false // 点击了"展开全文"
            // 获取全文
            const res = await getArticleContent()
            window.cfgs.imageList = res?.data?.fulltext?.imageList // 更新imageList
            window.cfgs.cover = res?.data?.fulltext?.cover || '' // 更新cover
            // 来自登录页+点了折叠按钮->展开全部
            if(isUnfoldContent && isFromLogin) {
                renderContent('#articleContent .display-content',res?.data?.fulltext?.content)
                renderHideDom()
                const artLookAllDom = document.querySelector('#artLookAll')
                if(artLookAllDom)artLookAllDom.style.display = 'none'
                window?.sohuSpm?.sendAction({ acode: 11066, clkParam: `displayMode:${cfgs?.displayMode};articleId:${cfgs?.newsId};`})
            // 已登录->展示部分正文+折叠按钮
            }else { 
                // 深度文章页：直接展示全文
                if(window?.sohuSpm?.getCodes()?.b == 'content-indepth') {
                    renderContent('#articleContent .display-content',res?.data?.fulltext?.content)
                }else {
                    renderContent('#articleContent .display-content',res?.data?.fulltext?.displayContent) // 折叠前的content
                    renderContent('#articleContent .hidden-content',res?.data?.fulltext?.hiddenContent || '') // 隐藏的content
                    // 更新折叠比例
                    const hiddenRatio = res?.data?.fulltext?.hiddenRatio
                    if(hiddenRatio) {
                        const hiddenRatioNum = document.querySelector('#artLookAll .surplus-btn .hidden-ratio-num')
                        if(hiddenRatioNum) hiddenRatioNum.innerHTML = hiddenRatio + '%'
                        showFoldtBtn('#artLookAll .surplus-normal-btn') // 折叠按钮
                    }else {
                        renderHideDom()
                        if(document.querySelector('#artLookAll'))document.querySelector('#artLookAll').style.display = 'none'
                    }
                }
            }
            emitRunClientJs()
        // 未登录
        } else {
            handleLoginFail()
        }
        localStorage.removeItem('clickUnfoldContent')
    } catch (error) {
        handleLoginFail()
    }
}

// 未登录|出错
const handleLoginFail = ()=>{
    showFoldtBtn('#artLookAll .surplus-login-btn')// 登录提示折叠按钮
    setDomImgVideo()
    emitRunClientJs()
    localStorage.removeItem('clickUnfoldContent')
}

// 显示折叠按钮
const showFoldtBtn = (selector) => {
    const foldtDom = document.querySelector(selector)
    if(foldtDom) {
        foldtDom.style.display = 'block'
        if(selector.includes('surplus-login-btn')) {
            foldtDom.addEventListener('click',(e)=>{
                e.stopPropagation() // 阻止冒泡
                localStorage.setItem('clickUnfoldContent',true)
                jumpLogin() // 跳转登录页
            })
        }
    }
}
// 渲染content
const renderContent = (selector,content) => {
    if(!content)return
    const contentDom = document.querySelector(selector)
    if(contentDom)contentDom.innerHTML = content
}

// 移除骨架屏
const removeSkeleton = () => {
    const skeletonDom = document.querySelector('#articleAuthorAccessSkeleton')
    if(skeletonDom)skeletonDom.style.display = 'none'
}

// 渲染标题
const renderTitle = (title) => {
    const titleContiner = document.querySelector('.article-page .title-info')
    if(titleContiner)titleContiner.innerHTML = title
}

// 触发客户端的js
const emitRunClientJs = ()=>{
     window?.eventBus?.$emit('runClientJs')
}

// 跳转首页
export const jumpHome = () => {
    if(isFocusArticle()) window.location.href = '//m.focus.cn'   // 焦点
    else window.location.href = '//m.sohu.com'
}
// 跳转登录
const jumpLogin = () => {
    let env = Utils.getEnvironment(); // 获取运行环境
    let spmData = window?.sohuSpm?.getCodes() || {}
    const spm = `${spmData?.a}.${spmData?.b}.content.login-limit.${spmData?.e}`
    const sohuLoginHost = {
        test: `https://test-m.sohu.com/login?type=1&origin=1`,
        pre: `https://pre-m.sohu.com/login?type=1&origin=1`,
        prod: `https://m.sohu.com/login?type=1&origin=1`,
    }
    const focusLoginHost = {
        test: `https://test-m.focus.cn/login`,
        pre: `https://login.focus.cn/login`,
        prod: `https://login.focus.cn/login`
    }
    if(isFocusArticle()) {
        window.location.href = `${focusLoginHost[env]}?ru=${window.location.href}&spm=${spm}` // 焦点
    }else {
        window.location.href = `${sohuLoginHost[env]}&r=${window.location.href}&spm=${spm}`
    }
}

// 给图片增加登录提示
const setDomImgVideo = () => {
    const img = document.querySelectorAll('.display-content img.content-image')
    if(img) {
        img.forEach((item) => {
            item.addEventListener('click', (e) => {
                item.dataset.clickHandled = 'true';
                jumpLogin()
            })
            const parent = item.parentElement
            if(parent) {
                if(item.getAttribute('data-type') == 'video') parent.classList.add('overlay-container-video') // 视频
                else  {
                    parent.classList.add('overlay-container-img') // 图片
                }
            }
        })
    }
    
}
// 显示隐藏的dom
const renderHideDom = ()=>{
    document.querySelectorAll('#articleContent .hide')?.forEach((item)=>{
        item?.classList?.remove('hide');
    })
}
// 显示前插视频dom
const renderHeadVideoDom = ()=>{
    const headVideoDom = document.querySelector('.relate_video-box')
    if(headVideoDom) {
        headVideoDom.style.display = 'block'
    }
}
// 是否是焦点页面
const isFocusArticle = ()=>{
    const spmA = window?.sohuSpm?.getCodes()?.a
    return !!spmA.includes('jd') // 焦点
}